module.exports = __webpack_public_path__ + "img/submenu03.c6c880c1.png";